import axios from "axios";

// P1-9: a 422 date_out_of_range asks staff to confirm, then retries the same request with force=true.
export const installDateGuard = () => {
  axios.interceptors.response.use(null, async (error) => {
    const res = error?.response;
    const d = res?.data?.detail;
    if (res?.status !== 422 || d?.code !== "date_out_of_range") throw error;
    const msg = `${d.field}: ${String(d.value).slice(0, 10)} is more than 1 year from the PF creation date (allowed ${d.allowed_from} – ${d.allowed_to}).\n\nSave anyway?`;
    if (error.config?._dateForced || !window.confirm(msg)) {
      res.data.detail = d.message;
      throw error;
    }
    return axios.request({ ...error.config, _dateForced: true, params: { ...(error.config.params || {}), force: true } });
  });
};
